import React, { useState, useRef, useContext } from "react";
import Clocks from "../components/Clocks";
import ArchiveTable from "../components/ArchiveTable";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { DataContext } from "../index";
import { addComma, gregorianToJalali, isFloat } from "../lib/helperFunctions";
import ReactPaginate from "react-paginate";

export default function Archive() {
  const [endDate, setEndDate] = useState(new DateObject());
  const [startDate, setStartDate] = useState(
    new DateObject().subtract(1, "day")
  );
  const [currentEndDate, setCurrentEndDate] = useState();
  const [currentStartDate, setCurrentStartDate] = useState();
  const [rateName, setRateName] = useState();
  const [currentRateName, setCurrentRateName] = useState();
  const [rates, setRates] = useState("");
  const [types, setTypes] = useState("");
  const dataContext = useContext(DataContext);
  const optionRef = useRef();
  const typeRef = useRef();
  const [allPageCount, setAllPageCount] = useState(
    isFloat(rates.count / 40)
      ? Math.floor(rates.count / 40) + 1
      : rates.count / 40
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [perPage, setPerPage] = useState(40);

  const handlePageClick = async (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * perPage);
    setOffset(offset);
    await handlePagesRate(offset);

    document
      .querySelector(".headers-container")
      .scrollIntoView({ behavior: "smooth" });
  };

  //Add By Mehrad/Start

  //Add By Mehrad/End

  const handleRates = async (e) => {
    e.preventDefault();
    setCurrentEndDate(endDate);
    setCurrentStartDate(startDate);
    setCurrentRateName(rateName);
    setOffset(0);

    try {
      const res = await fetch(`${process.env.REACT_APP_URL}/api/getArchive`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          rateName,
          startDate: startDate.unix * 1000,
          endDate: endDate.unix * 1000,
          offset: 0,
        }),
      });

      const result = await res.json();
      setRates(result);
    } catch (err) {}
  };
  const handlePagesRate = async (offset) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_URL}/api/getArchive`, {
        headers: {
          "content-type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          rateName: currentRateName,
          startDate: currentStartDate.unix * 1000,
          endDate: currentEndDate.unix * 1000,
          offset,
        }),
      });
      const result = await res.json();
      setRates(result);
    } catch (err) {}
  };

  return (
    <div className="archive-container">
      <div className="archive">
        <div className="archive-wrapper">
          <form className="utils-archive">
            <div className="dropdownContainer">
              <details>
                <summary ref={typeRef}> ارز / سکه</summary>
                <ul>
                  <li
                    value="ارز"
                    className="select-option"
                    onClick={(e) => {
                      typeRef.current.innerHTML = e.target.innerHTML;
                      setTypes(e.target.innerHTML);
                      typeRef.current.click();
                    }}
                  >
                    ارز
                  </li>
                  <li
                    value="سکه"
                    className="select-option"
                    onClick={(e) => {
                      typeRef.current.innerHTML = e.target.innerHTML;
                      setTypes(e.target.innerHTML);
                      typeRef.current.click();
                    }}
                  >
                    سکه
                  </li>
                </ul>
              </details>
            </div>
            <div className="dropdownContainer">
              <details>
                <summary ref={optionRef}>انتخاب ارز / سکه</summary>
                <ul>
                  {typeRef?.current?.innerHTML === "ارز"
                    ? dataContext?.titles?.map((item, i) => {
                        return (
                          <>
                            <li
                              value={item.name}
                              className="select-option"
                              onClick={(e) => {
                                optionRef.current.innerHTML =
                                  e.target.innerHTML;
                                setRateName(e.target.innerHTML);
                                optionRef.current.click();
                              }}
                            >
                              {item.name}
                            </li>
                          </>
                        );
                      })
                    : dataContext?.coinPrice?.map((item, i) => {
                        return (
                          <>
                            <li
                              value={item.coin.name}
                              className="select-option"
                              onClick={(e) => {
                                optionRef.current.innerHTML =
                                  e.target.innerHTML;
                                setRateName(e.target.innerHTML);
                                optionRef.current.click();
                              }}
                            >
                              {item.coin.name}
                            </li>
                          </>
                        );
                      })}
                </ul>
              </details>
            </div>
            <DatePicker
              calendar="persian"
              maxDate={endDate}
              minDate={new DateObject().subtract(1, "month")}
              locale="fa"
              required={true}
              className="datepicker-input"
              placeholder="از تاریخ"
              value={startDate}
              onChange={(e) => {
                if (endDate.unix - e.unix >= 7 * (24 * 60 * 60)) {
                  setStartDate(e);
                } else {
                }
              }}
            >
              از تاریخ
            </DatePicker>

            <DatePicker
              calendar="persian"
              locale="fa"
              required={true}
              minDate={startDate}
              maxDate={new DateObject()}
              className="datepicker-input"
              placeholder="تا تاریخ"
              value={endDate}
              onChange={setEndDate}
            >
              تا تاریخ
            </DatePicker>
            <button
              type="submit"
              className="search-btn"
              onClick={(e) => {
                handleRates(e);
              }}
            >
              جست و جو
            </button>
            <button
              className="search-btn"
              onClick={(e) => {
                e.preventDefault();
                setRateName("");
                optionRef.current.innerHTML =
                  "ارز/سکه مورد نظر خود را انتخاب کنید";
                typeRef.current.innerHTML = "ارز/سکه";
                setStartDate(new DateObject().subtract(3, "day"));
                setEndDate(new DateObject());
                setRates([]);
              }}
            >
              پاک کردن
            </button>
          </form>
          <section className="archive-tabl">
            <ArchiveTable rates={rates} offset={offset} />
            {rates.length !== 0 ? (
              <ReactPaginate
                previousLabel={"قبل"}
                nextLabel={"بعد"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={
                  isFloat(rates.count / perPage)
                    ? Math.floor(rates.count / perPage) + 1
                    : rates.count / perPage
                }
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            ) : null}
          </section>
        </div>
      </div>
      <Clocks />
    </div>
  );
}
